<template>
  <div class="auth-page window-height window-width column justify-center items-center">
    <router-view/>

    <div class="absolute-bottom-left q-pa-md row">
      <small class="q-mr-lg">
        <div class="q-pt-md">
          <a
            class="legal-link text-faded"
            target="_blank"
            :href="imprintLink"
          >
            {{ $t('imprint')}}
          </a>
        </div>
      </small>

      <small>
        <div class="q-pt-md">
          <a
            class="legal-link text-faded"
            target="_blank"
            :href="privacyPolicyLink"
          >
            {{ $t('privacy_policy')}}
          </a>
        </div>
      </small>
    </div>
  </div>
</template>

<script>
  import { general } from 'src/config'

  export default {
    meta () {
      return {
        title: this.$t('product_name')
      }
    },

    computed: {
      imprintLink () {
        return general.imprint_link
      },

      privacyPolicyLink () {
        return general.privacy_policy_link
      }
    }
  }
</script>

<style lang="stylus">
  .legal-link
    text-decoration: none;
</style>
